import { TranscriptButton } from '@pm2/element-toolbar';
import { resets } from '@ui/css';
import { printHtmlNodesToJsx, generateJsxKey } from '@utils/ast';
import { UniversalContextMenu } from '@utils/component-framework';
import { PostloadedImage } from '@utils/react';
import { image, contextMenu } from './printer.image.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function printImage(data, context) {
  const alignment = data.attributes?.["class"]?.includes("fr-fil") ? "left" : data.attributes?.["class"]?.includes("fr-fir") ? "right" : "middle";
  const inline = !!data.attributes?.["class"]?.includes("dii");
  const id = crypto.randomUUID();
  const transcript = data.extra?.["longDesc"];
  return /*#__PURE__*/jsxs("div", {
    className: image,
    "data-alignment": alignment,
    "data-inline": inline,
    children: [!!transcript?.length && /*#__PURE__*/jsx(UniversalContextMenu, {
      togglerClassName: contextMenu,
      layout: "solid",
      label: "\xC5bn kontekstmenuen",
      children: /*#__PURE__*/jsx(TranscriptButton, {
        nodeType: "image-component",
        transcript: transcript
      }, "transcript")
    }), /*#__PURE__*/jsx(PostloadedImage, {
      alt: "",
      ...data.props,
      "aria-details": `transcript-${id}`
    }), !!transcript?.length && /*#__PURE__*/jsx("div", {
      className: resets.screenReaderOnlyCls,
      id: `transcript-${id}`,
      children: printHtmlNodesToJsx(transcript)
    })]
  }, generateJsxKey(context));
}

export { printImage };
//# sourceMappingURL=printer.image.js.map
